import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';

import { isElloPaymentLinkContext } from '../../utils/navigation-constants';
import { colors } from '../theme/theme';

interface ImpersonationTimerProps {
    minutes: number;
    seconds: number;
}

/**
 * Timer display component for super user impersonation session
 * Shows remaining time at the top middle of the screen
 */
export const ImpersonationTimer: React.FC<ImpersonationTimerProps> = ({ minutes, seconds }) => {
    const { pathname, search } = useLocation();
    if (isElloPaymentLinkContext(pathname, search)) {
        return null;
    }

    const timeString = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    return (
        <Box
            sx={{
                position: 'fixed',
                top: 20,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1300,
                backgroundColor: colors.errorPreset[10],
                color: colors.fullWhite,
                px: 3,
                py: 1.5,
                borderRadius: 2,
            }}
        >
            <Stack direction="row" spacing={2} alignItems="center">
                <Typography variant="subtitle1">Super User Session:</Typography>
                <Typography
                    variant="h6"
                    sx={{
                        letterSpacing: 1,
                    }}
                >
                    {timeString}
                </Typography>
            </Stack>
        </Box>
    );
};
